import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventBuilderClass;
function KLoggingEventBuilder() {
  if (KLoggingEventBuilderClass === VOID) {
    class $ {
      constructor() {
        this.o2g_1 = null;
        this.p2g_1 = null;
        this.q2g_1 = null;
        this.r2g_1 = null;
        this.s2g_1 = null;
      }
    }
    initMetadataForClass($, 'KLoggingEventBuilder', KLoggingEventBuilder);
    KLoggingEventBuilderClass = $;
  }
  return KLoggingEventBuilderClass;
}
//region block: exports
export {
  KLoggingEventBuilder as KLoggingEventBuilder2t27iqox7tpd3,
};
//endregion

//# sourceMappingURL=KLoggingEventBuilder.mjs.map
